import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CreditCard, Coins, Receipt } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Subscription from "@/pages/Subscription";
import BillingCredits from "@/pages/BillingCredits";
import BillingHistory from "@/pages/BillingHistory";

const VALID_TABS = ["plan", "credits", "history"];

export default function Billing({ defaultTab = "plan" }) {
  const [params] = useSearchParams();
  const urlTab = params.get("tab");
  const [tab, setTab] = useState(VALID_TABS.includes(urlTab) ? urlTab : defaultTab);

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto animate-fade-up" data-testid="billing-page">
      <PageHeader
        eyebrow="// BILLING"
        title="Billing"
        description="Plans, payments, credits and usage — one place for everything money."
      />
      <div className="mb-6 flex items-center gap-1 border-b border-line overflow-x-auto" data-testid="billing-tabs">
        {[
          { id: "plan", label: "Plan & Payment", icon: CreditCard },
          { id: "credits", label: "Credits & Usage", icon: Coins },
          { id: "history", label: "Payment History", icon: Receipt },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            data-testid={`billing-tab-${t.id}`}
            className={`inline-flex shrink-0 items-center gap-2 px-4 py-2.5 text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition ${
              tab === t.id
                ? "border-brand-amber text-brand-amber"
                : "border-transparent text-ink-secondary hover:text-ink-primary"
            }`}
          >
            <t.icon className="h-4 w-4" /> {t.label}
          </button>
        ))}
      </div>
      {tab === "plan" ? <Subscription embedded /> : tab === "history" ? <BillingHistory /> : <BillingCredits embedded />}
    </div>
  );
}
